export enum Civility {
  Mr = 'M',
  Mrs = 'Mme',
  Other = 'Autre',
}
